import glutinfree from '../../assets/home/glutenfree.png'
import antioxidant from '../../assets/home/anti-Oxidant.png'
import nongmo from '../../assets/home/non-gmo.png'
import roastedinoliveoil from '../../assets/home/roasted-in-olive-oil.png'
import noaddedpreservatives from '../../assets/home/no-added-preservatives.png'
import header1 from '../../assets/home/makhana-header-pic.png'
import header2 from '../../assets/home/makhana-header-pic-2.png'
import header3 from '../../assets/home/makhana-header-pic-3.png'
import header4 from '../../assets/home/makhana-herader-pic-4.png'
import header5 from '../../assets/home/makhana-herader-pic-5.png'
import header6 from '../../assets/home/makhana-herader-pic-6.png'
const hero=()=>{

  
    return(
        <>
            <div  className="contianer-fluid" style={{background:'black'}}>
                <div
                  className="desktopviewheader"
                  style={{ width: "100%", height: "80vh" }}
                >
                  <div id="desktopCarousel" className="carousel slide">
                    <div className="carousel-inner">
                      <div className="carousel-item active">
                        <img src={header1} className="d-block w-100" alt="Desktop 1" />
                      </div>
                      <div className="carousel-item">
                        <img src={header2} className="d-block w-100" alt="Desktop 2" />
                      </div>
                      <div className="carousel-item">
                        <img src={header3} className="d-block w-100" alt="Desktop 3" />
                      </div>
                    </div>

                    <button
                      className="carousel-control-prev"
                      type="button"
                      data-bs-target="#desktopCarousel"
                      data-bs-slide="prev"
                    >
                      <span className="carousel-control-prev-icon"></span>
                    </button>

                    <button
                      className="carousel-control-next"
                      type="button"
                      data-bs-target="#desktopCarousel"
                      data-bs-slide="next"
                    >
                      <span className="carousel-control-next-icon"></span>
                    </button>
                  </div>
                </div>

                <div
                  className="mobileviewheader"
                  style={{ width: "100%", height: "70vh" }}
                >
                  <div id="mobileCarousel" className="carousel slide">
                    <div className="carousel-inner">
                      <div className="carousel-item active">
                        <img src={header4} className="d-block w-100" alt="Mobile 1" style={{
                          height:'auto'
                        }}/>
                      </div>
                      <div className="carousel-item">
                        <img src={header5} className="d-block w-100" alt="Mobile 2" />
                      </div>
                      <div className="carousel-item">
                        <img src={header6} className="d-block w-100" alt="Mobile 3" />
                      </div>
                    </div>

                    <button
                      className="carousel-control-prev"
                      type="button"
                      data-bs-target="#mobileCarousel"
                      data-bs-slide="prev"
                    >
                      <span className="carousel-control-prev-icon"></span>
                    </button>

                    <button
                      className="carousel-control-next"
                      type="button"
                      data-bs-target="#mobileCarousel"
                      data-bs-slide="next"
                    >
                      <span className="carousel-control-next-icon"></span>
                    </button>
                  </div>
                </div>
                
                <div className="slider-wrapper"
                  style={{
                    background:'#FFDA01'
                  }}
                >
                  <div className="slider-text text-uppercase" style={{color:'black'}}>
                    <span className="slide-item"><img src={nongmo}/> Non-GMO</span>
                    <span className="slide-item"><img src={noaddedpreservatives}/> NO Added Preservatives</span>
                    <span className="slide-item"><img src={roastedinoliveoil}/> Roasted in olive oil</span>
                    <span className="slide-item"><img src={antioxidant}/> anti-oxidants</span>
                    <span className="slide-item"><img src={glutinfree}/> glutine free</span>
                    
                    <span className="slide-item"><img src={nongmo}/> Non-GMO</span>
                    <span className="slide-item"><img src={noaddedpreservatives}/> NO Added Preservatives</span>
                    <span className="slide-item"><img src={roastedinoliveoil}/> Roasted in olive oil</span>
                    <span className="slide-item"><img src={antioxidant}/> anti-oxidants</span>
                    <span className="slide-item"><img src={glutinfree}/> glutine free</span>
                    

                    <span className="slide-item"><img src={nongmo}/> Non-GMO</span>
                    <span className="slide-item"><img src={noaddedpreservatives}/> NO Added Preservatives</span>
                    <span className="slide-item"><img src={roastedinoliveoil}/> Roasted in olive oil</span>
                    <span className="slide-item"><img src={antioxidant}/> anti-oxidants</span>
                    <span className="slide-item"><img src={glutinfree}/> glutine free</span>
                    
                    
                  </div>

                    <div className="slider-text text-uppercase">
                    <span className="slide-item"><img src={nongmo}/> Non-GMO</span>
                    <span className="slide-item"><img src={noaddedpreservatives}/> NO Added Preservatives</span>
                    <span className="slide-item"><img src={roastedinoliveoil}/> Roasted in olive oil</span>
                    <span className="slide-item"><img src={antioxidant}/> anti-oxidants</span>
                    <span className="slide-item"><img src={glutinfree}/> glutine free</span>
                    
                    <span className="slide-item"><img src={nongmo}/> Non-GMO</span>
                    <span className="slide-item"><img src={noaddedpreservatives}/> NO Added Preservatives</span>
                    <span className="slide-item"><img src={roastedinoliveoil}/> Roasted in olive oil</span>
                    <span className="slide-item"><img src={antioxidant}/> anti-oxidants</span>
                    <span className="slide-item"><img src={glutinfree}/> glutine free</span>
                    

                    <span className="slide-item"><img src={nongmo}/> Non-GMO</span>
                    <span className="slide-item"><img src={noaddedpreservatives}/> NO Added Preservatives</span>
                    <span className="slide-item"><img src={roastedinoliveoil}/> Roasted in olive oil</span>
                    <span className="slide-item"><img src={antioxidant}/> anti-oxidants</span>
                    <span className="slide-item"><img src={glutinfree}/> glutine free</span>
                    
                  </div>
                
                </div>
                
            </div>
        </>
    )
}
export default hero
